import { UploadContactsResponse } from 'types/contact.type';
import axiosInstance from './config/api';

export interface UploadWorkflowContact {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    crmId?: string;
    crmStatus?: string;
}

interface UploadWorkflowContactsRequest {
    workflowId: string;
    contacts: UploadWorkflowContact[];
}

export const postUploadWorkflowContacts = async (
    data: UploadWorkflowContactsRequest
): Promise<UploadContactsResponse> => {
    return await axiosInstance.post<UploadContactsResponse>('/workflows/upload', data).then((res) => res.data);
};
